<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between">
                <div class="flex-sub margin-right">
                    <div class="flex align-center ">
                        <div class="flex align-center margin-right-sm ">
                            <span>关键字：</span>
                            <el-input v-model="name" placeholder="请输入关键字" class="flex-sub"></el-input>
                        </div>
                        <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </div>
                </div>
                <div>
                    <el-button type="primary" @click="editItem(0)">添加队伍</el-button>
                </div>

            </div>

            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                </div>
            </div>

            <el-table :data="lists" header-row-class-name="table-header" row-class-name="table-row" alig="center" border
                style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="队伍名称" prop="name"></el-table-column>
                <el-table-column label="队长名称" prop="duizhang_name"></el-table-column>
                <el-table-column label="队长手机号" prop="duizhang_phone"></el-table-column>
                <el-table-column label="创建时间" prop="create_time"></el-table-column>
                <el-table-column label="操作" width="240">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button size="small" type="primary" @click="editItem(scope.row.id)">编辑
                            </el-button>
                            <el-button size="small" type="primary" @click="recordItem(scope.row.id)">活动记录
                            </el-button>
                            <el-button size="small" type="primary" @click="delItem(scope.row.id)">删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="lists.length > 0" class="page-all" background @current-change="getList"
                :current-page.sync="page" :page-size="limit" layout="prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { delTeam, teamList } from "@/api/gzh";

export default {
    name: "shopping",
    components: {  },
    data() {
        return {
            name: '',
            page: 1,
            limit: 10,
            total: 0,
            lists: [],

        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "双暖为老 / 队伍管理 / 队伍列表", false);
        this.getList()
    },
    methods: {
        //  删除
        delItem(id) {
            this.$confirm('您确定要删除该活动吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDelete(id);
            });
        },
        async sureDelete(id) {
            let _state = await delTeam(id);
            this.getList();
            this.$message.success(_state.info);
        },

        //  活动编辑
        editItem(id) {
            this.$router.push('/home/gzh/teams/add/' + id)
        },

        recordItem(id) {
            this.$router.push('/home/gzh/teams/active/' + id)
        },

        //  搜索
        handleSearch() {
            this.page = 1
            this.getList()
        },
        //  获取活动列表
        async getList() {
            let _data = await teamList(
                this.name,
                this.page,
                this.limit,
            )
            this.lists = _data.data
            this.total = _data.total_number
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss"></style>
